<div class="progress-wrapper">
  <div class="progress progress-{{rate}}">
    <div class="back">{{ statusName }}</div>
    <div class="front front-{{rate}}">{{ statusName }}</div>
  </div>
</div>
